export const SAVE_PATIENT_DATA = 'SAVE_PATIENT_DATA'
